<div class="topbar-title">
  <div class="topbar-title__icon-container disable-select">
    <app-icon [src]="icon()" [size]="19" />
  </div>
  <span class="topbar-title__label body-sm-semibold">{{ label() }}</span>
</div>
